import { type ReactElement, useMemo } from 'react'
import { isEmpty, isProgramId, type ProgramId } from '@terros/common'
import { MultiSelect } from '@mantine/core'
import { usePrograms } from '@front/model'

type Props = {
  selectedProgramIds: ProgramId[]
  setProgramIds: (programIds: ProgramId[]) => void
  filterProgramId: ProgramId | undefined
}

export const ProgramMultiSelect = ({ selectedProgramIds, setProgramIds, filterProgramId }: Props): ReactElement => {
  const { data: programs } = usePrograms()

  const options = useMemo(() => {
    if (!programs) return []
    return programs
      .filter((program) => program.programId !== filterProgramId)
      .map((program) => ({
        value: program.programId,
        label: program.name,
      }))
  }, [programs, filterProgramId])

  return (
    <MultiSelect
      clearable
      searchable
      data={options}
      label='Programs'
      placeholder={isEmpty(selectedProgramIds) ? 'Select programs' : undefined}
      value={selectedProgramIds}
      onChange={(programIds) => setProgramIds(programIds.filter(isProgramId))}
    />
  )
}
